var React = require('react');

function Home (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Home 1"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_5","data-name":"Layer 5"},React.createElement("path",{"d":"M287.24,115,149.18,1.61a7.07,7.07,0,0,0-9,0L2.58,115a7.09,7.09,0,0,0,4.51,12.56H40.14V249.84a7.09,7.09,0,0,0,7.09,7.09h71.44a7.09,7.09,0,0,0,7.09-7.09V164.51h37.86v85.33a7.09,7.09,0,0,0,7.08,7.09h71.45a7.09,7.09,0,0,0,7.08-7.09V127.53h33.52A7.09,7.09,0,0,0,287.24,115Zm-45.09-1.61a7.09,7.09,0,0,0-7.09,7.09V242.75H177.79V157.42a7.09,7.09,0,0,0-7.09-7.09h-52a7.09,7.09,0,0,0-7.08,7.09v85.33H54.31V120.44a7.09,7.09,0,0,0-7.08-7.09H26.83L144.7,16.26,263,113.35Z"})))]);
}

Home.defaultProps = {"viewBox":"0 0 289.83 256.93"};

module.exports = Home;

Home.default = Home;
